import { render, staticRenderFns } from "./SaveForLaterButton.vue?vue&type=template&id=744c4d0d&scoped=true"
import script from "./SaveForLaterButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveForLaterButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SaveForLaterButton.vue?vue&type=style&index=0&id=744c4d0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744c4d0d",
  null
  
)

export default component.exports